import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@sumologic/yama-ds-components/hooks';

import Translate from '~/components/Translate/Translate';
import BlankSpacePlaceholder from '~/components/BlankSpacePlaceholder/BlankSpacePlaceholder';
import {
    NoSearchResultLightAsset,
    NoSearchResultDarkAsset
} from '@sumologic/yama-ds-assets';

const NoResult = ({
    className = '',
    classNameTitle = '',
    centerSuffix,
    actions,
    description,
    width = 72,
    height = 72,
    title
}) => {
    const currentTheme = useTheme()?.palette?.mode || 'dark';
    const NoSearchResultAsset =
        currentTheme === 'light'
            ? NoSearchResultLightAsset
            : NoSearchResultDarkAsset;

    return (
        <BlankSpacePlaceholder
            className={className}
            centerSuffix={centerSuffix}
            title={title || <Translate message="No results found" />}
            classNameTitle={classNameTitle}
            description={description}
            actions={actions}
            img={<NoSearchResultAsset width={width} height={height} />}
        />
    );
};

NoResult.propTypes = {
    className: PropTypes.string,
    classNameTitle: PropTypes.string,
    centerSuffix: PropTypes.string,
    actions: PropTypes.element,
    description: PropTypes.element,
    width: PropTypes.number,
    height: PropTypes.number,
    title: PropTypes.node
};

export default NoResult;
